exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4a914851] .custom-dialog .el-dialog__header{padding:10px 20px}[data-v-4a914851] .custom-dialog .el-dialog__header .el-dialog__title{font-size:17px}[data-v-4a914851] .custom-dialog .el-dialog__header .el-dialog__headerbtn{top:15px}[data-v-4a914851] .custom-dialog .el-dialog__header .el-dialog__headerbtn .i{font-size:large}[data-v-4a914851] .custom-dialog .el-dialog__footer{padding:10px 20px}.border[data-v-4a914851] .el-dialog__header{border-bottom:1px solid #e8e8e8}.border[data-v-4a914851] .el-dialog__footer{border-top:1px solid #e8e8e8}\n", ""]);

// exports
